import AOS from 'aos';

(() => {
  const ready = () => {
    AOS.init({
      once: true,
      duration: 650,
      easing: 'ease-out-quart',
    });

    const header = document.querySelector('.site-header');
    if (header) {
      const updateHeaderHeight = () => {
        const height = header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      };

      window.addEventListener('resize', updateHeaderHeight);
      updateHeaderHeight();

      // Ensure height is correct after images (logo) have loaded
      window.addEventListener('load', updateHeaderHeight);

      // MutationObserver to catch changes in header height (e.g. content changes)
      const observer = new MutationObserver(updateHeaderHeight);
      observer.observe(header, { attributes: true, childList: true, subtree: true });

      const handleScroll = () => {
        if (window.scrollY > 250) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      };

      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Initial check

      // Hamburger Menu Toggle
      const menuToggle = header.querySelector('.menu-toggle');
      const menuClose = header.querySelector('.menu-close');
      const navigation = header.querySelector('.main-navigation');
      if (menuToggle && navigation) {
        const toggleMenu = (e) => {
          e.preventDefault();
          const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
          menuToggle.setAttribute('aria-expanded', !isExpanded);
          navigation.classList.toggle('is-active');
          document.body.classList.toggle('menu-open');
        };

        menuToggle.addEventListener('click', toggleMenu);
        
        if (menuClose) {
          menuClose.addEventListener('click', toggleMenu);
        }

        // Close menu when clicking a link
        const menuLinks = navigation.querySelectorAll('a');
        menuLinks.forEach((link) => {
          link.addEventListener('click', (e) => {
            const parentLi = link.parentElement;
            const hasSubmenu = parentLi.classList.contains('menu-item-has-children');

            // If it's a mobile view and has a submenu, toggle it
            if (window.innerWidth <= 991 && hasSubmenu) {
              e.preventDefault();
              parentLi.classList.toggle('is-open');
              return;
            }

            menuToggle.setAttribute('aria-expanded', 'false');
            navigation.classList.remove('is-active');
            document.body.classList.remove('menu-open');
          });
        });
      }
    }

    console.info('HROC Base theme loaded');

    // Initialize Hero Slider & General Slider
    if (typeof Swiper !== 'undefined') {
      const sliders = document.querySelectorAll('.hroc-hero-slider, .hroc-slider, .hroc-split-slider');
      sliders.forEach((slider) => {
        const isHero = slider.classList.contains('hroc-hero-slider');
        const hasStaticContent = slider.classList.contains('has-static-content');
        const isSplit = slider.classList.contains('hroc-split-slider');
        const autoplayEnabled = slider.getAttribute('data-autoplay') === 'true';
        const autoplayDelay = parseInt(slider.getAttribute('data-autoplay-delay'), 10) || 4000;

        const swiperOptions = {
          loop: true,
          pagination: {
            el: isSplit ? slider.querySelectorAll('.swiper-pagination') : slider.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          on: {
            slideChange: (s) => {
              if (isHero && hasStaticContent) {
                const realIndex = s.realIndex;
                const ctaWrappers = slider.querySelectorAll('.hroc-hero__static-ctas .hroc-hero__cta-wrapper');
                ctaWrappers.forEach((wrapper) => {
                  if (parseInt(wrapper.getAttribute('data-slide-index'), 10) === realIndex) {
                    wrapper.classList.add('is-active');
                  } else {
                    wrapper.classList.remove('is-active');
                  }
                });
              }
            },
          },
        };

        if (autoplayEnabled) {
          swiperOptions.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        const swiper = new Swiper(slider, swiperOptions);
      });
    }

    // Initialize Case Studies Grid Slider (Mobile only)
    if (typeof Swiper !== 'undefined') {
      const caseStudyGrids = document.querySelectorAll('.hroc-case-studies-grid__container');
      caseStudyGrids.forEach((grid) => {
        new Swiper(grid, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: grid.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            // when window width is >= 769px
            769: {
              enabled: false,
            },
          },
        });
      });
    }

    // Initialize Animated Header
    const animatedHeaders = document.querySelectorAll('.hroc-animated-header');
    animatedHeaders.forEach((header) => {
      const words = header.querySelectorAll('.hroc-animated-header__word');
      if (words.length <= 1) return;

      let currentIndex = 0;
      setInterval(() => {
        const currentWord = words[currentIndex];
        currentWord.classList.remove('is-visible');
        currentWord.classList.add('is-hidden');

        currentIndex = (currentIndex + 1) % words.length;

        const nextWord = words[currentIndex];
        nextWord.classList.remove('is-hidden');
        nextWord.classList.add('is-visible');
      }, 3000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
